/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import React from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { Flex, IconButton } from '@chakra-ui/react';

interface JsonNavigationButtonsProps {
  handlePrevious: () => void;
  handleNext: () => void;
  isDisabled: boolean;
}

export const JsonNavigationButtons: React.FC<JsonNavigationButtonsProps> = ({
  handlePrevious,
  handleNext,
  isDisabled,
}) => (
  <Flex flex={1} gap={2} alignItems="center">
    <IconButton
      aria-label="up"
      onClick={handlePrevious}
      icon={<ChevronUpIcon fontSize="2rem" />}
      isDisabled={isDisabled}
      bgColor="#000"
      color="#fff"
      _hover={{ bgColor: '#000', transform: 'scale(1.05)' }}
    />
    <IconButton
      aria-label="down"
      onClick={handleNext}
      icon={<ChevronDownIcon fontSize="2rem" />}
      isDisabled={isDisabled}
      bgColor="#000"
      color="#fff"
      _hover={{ bgColor: '#000', transform: 'scale(1.05)' }}
    />
  </Flex>
);
